export default __webpack_public_path__ + "media/images/react_icons/message-lines-fbaadd63b7b069ddf4b0aa99ea04e2f0.svg";